import type { ColumnDef } from "@tanstack/react-table";
import type { PhaseRow } from "../types/Phase";
import { useFlags } from "launchdarkly-react-client-sdk";

export const usePhaseColumns = (): ColumnDef<PhaseRow>[] => {
  const { configAllLanguageTabs } = useFlags();
  const showLanguage = !!configAllLanguageTabs;

  return [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row }) => row.original.name,
    },
    ...(showLanguage
      ? [
          {
            accessorKey: "sowLanguage",
            header: "Service Description",
            cell: ({ row }) => row.original.sowLanguage ?? "—",
          },
        ]
      : []),
    {
      accessorKey: "isDefault",
      header: "Default",
      cell: ({ row }) => (row.original.isDefault ? "Yes" : "No"),
    },
  ];
};
